import { PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    sunken: string;
    outline: string;
    softBorder: string;
    navItem: {
      normal: string;
      hover: string;
      activeBackground: string;
      hoverBackground: string;
    };
  }
  interface PaletteOptions {
    sunken?: string;
    outline?: string;
    softBorder?: string;
    navItem?: {
      normal: string;
      hover: string;
      activeBackground: string;
      hoverBackground: string;
    };
  }
}

export const DARK_BACKGROUND = '#282826';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  sunken: '#f4f5f7',
  outline: '#c9cdd4',
  softBorder: '#e4e6ea',
  navItem: {
    normal: '#1c2025',
    hover: '#53657d',
    activeBackground: '#eef5fc',
    hoverBackground: '#e4eef9',
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  background: {
    default: DARK_BACKGROUND,
    paper: '#2c2c2a',
  },
  sunken: '#232421',
  divider: '#3b3b38',
  outline: '#464641',
  softBorder: 'rgba(255, 255, 255, 0.075)',
  text: {
    primary: '#e6e8ec',
    secondary: '#a7abb4',
  },
  primary: {
    main: '#5964f2',
  },
  info: {
    main: '#669bb2',
  },
  navItem: {
    normal: '#c1c4cb',
    hover: '#f4f5f7',
    activeBackground: '#393a37',
    hoverBackground: '#41423f',
  },
};
